module.exports = __webpack_public_path__ + "img/icon_arrow_small.d3660e95.svg";